module.exports = __webpack_public_path__ + "img/H02028-38.51b56f2f.jpg";